export default "__VITE_ASSET__UpY__OeA__"